import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "websites" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Your websites")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"175px"} }, null, -1)
const _hoisted_4 = { class: "wtable" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", { class: "wtr" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "wname" }, "Website Name"),
  /*#__PURE__*/_createElementVNode("th", { class: "wemail" }, "Website Email"),
  /*#__PURE__*/_createElementVNode("th", { class: "wurl" }, "Website Url"),
  /*#__PURE__*/_createElementVNode("th", { class: "wid" }, "Website Id")
], -1)
const _hoisted_6 = { class: "tr" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "wurl" }
const _hoisted_9 = ["innerHTML", "href"]
const _hoisted_10 = { class: "wurl" }
const _hoisted_11 = ["href", "innerHTML"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("td", null, [
          _createElementVNode("button", {
            class: "btn btn-primary right",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetch_websites && _ctx.fetch_websites(...args)))
          }, "Get Websites"),
          _createElementVNode("button", {
            class: "btn btn-primary right",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.add_website && _ctx.add_website(...args)))
          }, "Add New")
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.websites_country, (ele) => {
        return (_openBlock(), _createElementBlock("tr", _hoisted_6, [
          _createElementVNode("td", {
            class: "wname",
            innerHTML: ele.name
          }, null, 8, _hoisted_7),
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("a", {
              innerHTML: ele.email,
              href: 'mailto:' + ele.email
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("td", _hoisted_10, [
            _createElementVNode("a", {
              href: ele.url,
              innerHTML: ele.url
            }, null, 8, _hoisted_11)
          ]),
          _createElementVNode("td", {
            class: "wview btn-primary",
            onClick: ($event: any) => (_ctx.set_website_id(ele.id, ele.name))
          }, "View", 8, _hoisted_12)
        ]))
      }), 256))
    ])
  ]))
}